import SideBySideIcon from 'common/icons/SideBySide';
import StackIcon from 'common/icons/Stack';

export const SIDE_BY_SIDE_LAYOUT_LABEL = 'Side by Side';
export const STACK_LAYOUT_LABEL = 'Stack';
export const SIDE_BY_SIDE_LAYOUT = 'sideBySide';
export const STACK_LAYOUT = 'stacked';
export const LAYOUT_OPTIONS = [SIDE_BY_SIDE_LAYOUT, STACK_LAYOUT];
export const LAYOUT_OPTIONS_WITH_ICONS = [
    {
        layout: SIDE_BY_SIDE_LAYOUT,
        Icon: SideBySideIcon,
        label: SIDE_BY_SIDE_LAYOUT_LABEL,
    },
    {
        layout: STACK_LAYOUT,
        Icon: StackIcon,
        label: STACK_LAYOUT_LABEL,
    },
];

export const EVENT_MULTI_SESSION = '2';

export const NODE_ID_HEADER = 'header';
export const NODE_ID_BACK_BUTTON = 'backButton';
export const NODE_ID_LOGO = 'logo';
export const NODE_ID_COVER = 'cover';
export const NODE_ID_DATE = 'date';
export const NODE_ID_EVENT_TITLE = 'eventTitle';
export const NODE_ID_PARAGRAPH = 'paragraph';
export const NODE_ID_REGISTER_BUTTON = 'registerButton';
export const NODE_ID_VIEW_AGENDA = 'viewAgenda';
export const NODE_ID_SESSION_NAVIGATION = 'sessionNavigation';
export const NODE_ID_SESSION_SEARCH = 'sessionSearch';
export const NODE_ID_SESSION_FILTER = 'sessionFilter';
export const NODE_ID_SESSION_LIST = 'sessionList';
export const NODE_ID_SESSION_TAB = 'sessionTab';
export const NODE_ID_SESSIONS_CALENDAR_DOWNLOAD = 'addSessionsToCalendarButton';
export const NODE_ID_SESSION_CARDS = 'sessionCards';
export const NODE_ID_SPEAKER_MODALS = 'speakerModals';
export const NODE_ID_ADD_SESSION_TO_CALENDAR = 'addSessionToCalendarModal';
export const NODE_ID_CALL_TO_ACTION = 'callToAction';
export const NODE_ID_CALL_TO_ACTION_HEADLINE = 'callToActionHeadline';
export const NODE_ID_CALL_TO_ACTION_PARAGRAPH = 'callToActionParagraph';
export const NODE_ID_CALL_TO_ACTION_BUTTON = 'callToActionButton';

export const NODE_DISPLAY_NAME_HEADER = 'Header';
export const NODE_DISPLAY_NAME_BACK_BUTTON = 'Back Button';
export const NODE_DISPLAY_NAME_LOGO = 'Logo';
export const NODE_DISPLAY_NAME_COVER = 'Cover';
export const NODE_DISPLAY_NAME_DATE = 'Date';
export const NODE_DISPLAY_NAME_EVENT_TITLE = 'Event Title';
export const NODE_DISPLAY_NAME_PARAGRAPH = 'Paragraph';
export const NODE_DISPLAY_NAME_REGISTER_BUTTON = 'Register Button';
export const NODE_DISPLAY_NAME_VIEW_AGENDA = 'Agenda Button';
export const NODE_DISPLAY_NAME_SESSION_NAVIGATION = 'Session Navigation';
export const NODE_DISPLAY_NAME_SESSION_SEARCH = 'Session Search';
export const NODE_DISPLAY_NAME_SESSION_FILTER = 'Filter Dropdown';
export const NODE_DISPLAY_NAME_SESSION_LIST = 'Session List';
export const NODE_DISPLAY_NAME_SESSION_TAB = 'Tab Filter';
export const NODE_DISPLAY_NAME_SESSIONS_CALENDAR_DOWNLOAD = 'Sessions Calendar Download';
export const NODE_DISPLAY_NAME_SESSION_CARDS = 'Session Cards';
export const NODE_DISPLAY_NAME_SPEAKER_MODALS = 'Speaker Modals';
export const NODE_DISPLAY_NAME_ADD_SESSION_TO_CALENDAR_MODAL = 'Calendar Attachment Modal';
export const NODE_DISPLAY_NAME_CALL_TO_ACTION = 'Call to Action';
export const NODE_DISPLAY_NAME_CALL_TO_ACTION_HEADLINE = 'Headline';
export const NODE_DISPLAY_NAME_CALL_TO_ACTION_PARAGRAPH = 'Paragraph';
export const NODE_DISPLAY_NAME_CALL_TO_ACTION_BUTTON = 'Button';

export const NODE_DESCENDANT_KEY_UNREGISTER_SESSION_BUTTON = 'unregisterSessionButton';
export const NODE_DESCENDANT_KEY_REGISTER_SESSION_BUTTON = 'registerSessionButton';
export const NODE_DESCENDANT_KEY_UNREGISTER_WAITLIST_SESSION_BUTTON = 'unregisterWaitlistSessionButton';
export const NODE_DESCENDANT_KEY_REGISTER_WAITLIST_SESSION_BUTTON = 'registerWaitlistSessionButton';
export const NODE_DESCENDANT_KEY_ADD_TO_CALENDAR_BUTTON = 'addToCalendarButton';
export const NODE_DESCENDANT_KEY_SESSION_LABEL = 'statusLabel';
